module.exports = __webpack_public_path__ + "media/images/banners/nft_banner-6aa99811e6cc68b6badaf34959d8e34b.png";